import ReactModal from 'react-modal'

import './modal.scss'

ReactModal.setAppElement('#vit__create-reservation')

const Modal = ({
  isOpen,
  children,
  onRequestClose,
  contentClassName = '',
  overlayClassName = '',
}) => (
  <ReactModal
    isOpen={isOpen}
    onRequestClose={onRequestClose ? onRequestClose : null}
    className={`modal ${contentClassName}`}
    overlayClassName={`modal-overlay  ${overlayClassName}`}
    bodyOpenClassName={'modal-open'}
  >
    {children}
  </ReactModal>
)

export default Modal
